import React from 'react';

const textArea = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);

	let maxlengthVal = 200;
	if(fieldDetail.maxlength) {
		maxlengthVal = fieldDetail.maxlength;
	}
	return (
	    <textarea style={{"resize": "none"}} onChange={props.changed} name={props.fieldKey} className={fieldDetail.classname} placeholder={fieldDetail.placeHolder} value={fieldDetail.value} maxlength={maxlengthVal}></textarea>
	);
}

export default textArea;